import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=0cb82dc6&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=0cb82dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb82dc6",
  null
  
)

export default component.exports